import React from 'react';
import { Footer, Navbar } from '../components';
import PricingPage from "../components/pricing/PricingPage";
import Seo from '../components/Seo';

function Pricing() {
    return (
        <div>
            <Seo title="Pricing" description="Simple, transparent pricing for accepting payments with WayaQuick." />
            <Navbar />
            <PricingPage />
            <Footer />
        </div>
    )
}

export default Pricing
